import api from "@/api/api-v2-config";

export async function getNotificationAxios() {    
    return await api.get("notifications");
}

export async function getPushNotificationAxios() {    
    return await api.get("notifications/pushnotification");
}

export async function putPushNotificationAxios(id) {    
    return await api.put("notifications/pushnotification", {
        id: id, 
    });
}